<div *ngIf="this.originalBill" class="flex grid w-full">
    <div class="flex col-9 flex-column">
        <div>{{this.originalBill.case.id}} - {{this.originalBill.category.categoryName}} </div>
        <div>{{this.originalBill.patient.fullName}}</div>
        <div>{{this.repricedBill().totalRepricedAmount | currency}}</div>
        <div>Submitted: {{getSubmissionDateDisplay()}}</div>
        <div *ngIf="this.repricedBill().payerSubmissionDate">Payer Submitted: {{getPayerSubmissionDateDisplay()}}</div>
    </div>

    <div class="flex col-3 flex-column align-items-center justify-items-end">
        <p-button icon="pi pi-file-export" [rounded]="true" [text]="true" [raised]="true" (onClick)="editorVisible = true"></p-button>
    </div>
</div>

<p-dialog #sendDialog [(visible)]="editorVisible">
    <div class="flex grid mt-5">
        <div class="flex col-12 flex-column gap-5">
                <p-floatLabel>
                    <p-dropdown id="senders" [options]="(senders$ | async) || []" optionLabel="name" [(ngModel)]="selectedSender"></p-dropdown>
                    <label for="senders">Sender</label>
                </p-floatLabel>

                <p-floatLabel>
                    <p-dropdown id="payers" [options]="(payers$ | async) || []" optionLabel="name" [(ngModel)]="selectedPayer"></p-dropdown>
                    <label for="payers">Payer</label>
                </p-floatLabel>
        </div>
        <div class="flex col-12">
            {{this.lastError}}
        </div>
        <div class="flex col-12 flex-column w-full align-items-center justify-content-center">
            <p-buttonGroup>
                <p-button [disabled]= "!selectedSender || !selectedPayer || submitting" label="Send" [icon]=" submitting ? 'pi pi-spin pi-spinner' : 'pi pi-check'" (onClick)="submitToClearinghouse()"></p-button>
                <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="editorVisible = false"></p-button>
            </p-buttonGroup>
        </div>
    </div>
    
</p-dialog>